<template>
  <section class="padd-40">
    <div class="container media-padd2">
      <el-carousel :interval="5000" arrow="always" :height="carouselHeight" ref="homeAd">
          <el-carousel-item v-for="item in ads" :key="item" class="ads">
            <span v-html="item"></span>
          </el-carousel-item>
        </el-carousel>
    </div>
    </section>
</template>
<style>
.ads img {
    max-width: 100%;
    max-height: 100%;
    width:100%;
    height:100%;
}
@media only screen and (max-width:480px) {
  .media-padd2 {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .padd-40 {
    padding-top: 10px !important;
  }
}
</style>
<script>
export default {
  name: 'HomeRoll',
  data: function () {
  return {
    carouselHeight: '347px',
    ads: ['<ins data-revive-zoneid="98" data-revive-id="e6dd1ba23f7506ab80d6247cea9b09d0"></ins>',
        '<ins data-revive-zoneid="99" data-revive-id="e6dd1ba23f7506ab80d6247cea9b09d0"></ins>', 
        '<ins data-revive-zoneid="100" data-revive-id="e6dd1ba23f7506ab80d6247cea9b09d0"></ins>',
        '<ins data-revive-zoneid="101" data-revive-id="e6dd1ba23f7506ab80d6247cea9b09d0"></ins>',
        '<ins data-revive-zoneid="102" data-revive-id="e6dd1ba23f7506ab80d6247cea9b09d0"></ins>']
  }
  },
  mounted: function () {
    let width= this.$refs.homeAd.$el.clientWidth
    this.carouselHeight = parseInt(width * 222.0 / 600.0).toString() + 'px'
    window.addEventListener('resize', () => {
      let w = this.$refs.homeAd.$el.clientWidth
      this.carouselHeight = parseInt(w * 222.0 / 600.0).toString() + 'px'
    })
  }
}
</script>